import React from 'react';

function Partner() {
  return (
    <div className="bg-[#fdf4e4] py-16 px-6 md:px-24 text-[#3f3a32]">
      <div className="flex flex-col md:flex-row items-start gap-12">
        {/* Left side: Text */}
        <div className="w-full md:w-3/5">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 font-mortend headings">
            COLLABORATE WITH US
          </h2>

          <div className="mb-6">
            <h3 className="text-lg font-bold mb-2 ">For Tour Operators & Guides</h3>
            <p className="text-base ">
              Sigiriya VR is an invaluable tool for tour guides, travel agencies, and tourism companies, 
              offering an unparalleled way to introduce visitors to the story of Sigiriya.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-bold mb-2 ">Tour Guide Policy</h3>
            <p className="text-base  mb-2">
              We require that all tour guides experience Sigiriya VR first-hand before promoting it. 
              We strongly believe that once they see it, they’ll love it.
            </p>
            <ul className="list-disc list-inside space-y-1 pl-4 text-base ">
              <li>Free access for all licensed national tour guides.</li>
              <li>Register with us after experiencing it to officially promote the product.</li>
            </ul>
          </div>

          <div className="mt-8 text-center">
          <a href="https://wa.me/94741100816" target='_blank' rel="noopener noreferrer">
            <button className="bg-[#3f3a32] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#2d2b29] transition">
              Become a partner
            </button>
            </a>
          </div>
        </div>

        {/* Right side: Image (hidden on mobile) */}
        <div className="hidden md:block md:w-2/5 py-8">
          <img 
            src={require('../assets/images/partner.png')} 
            alt="Partner with us" 
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
}

export default Partner;
